import { FormElement, HelpIcon, InputTextIcon } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const LockedReplyToEmail = ({ value }) => {
  const intl = useIntl()

  const Help = () => (
    <HelpIcon
      text={intl.formatMessage({ id: 'Load.PecPlus.replyToPecTooltip' })}
    />
  )

  return (
    <FormElement
      label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
      required
      LabelRightComponent={Help}
    >
      <InputTextIcon value={value} disabled />
    </FormElement>
  )
}

LockedReplyToEmail.propTypes = {
  value: PropTypes.string
}

export default LockedReplyToEmail
